import { implementAdminCustomExpressions } from '../../__generated/admin-implementation.js';
import { Finish, RawMaterial } from '../../__generated/admin-model/index.js';
const rawMaterialOptions = [
    {
        label: 'SS304',
        value: RawMaterial.ss304
    },
    {
        label: 'SS316',
        value: RawMaterial.ss316
    },
    {
        label: 'Aluminium',
        value: RawMaterial.aluminium
    },
    {
        label: 'Brass',
        value: RawMaterial.brass
    }
];
const finishOptions = [
    {
        label: 'Brushed',
        value: Finish.brushed
    },
    {
        label: 'Milled',
        value: Finish.milled
    },
    {
        label: 'Chequer',
        value: Finish.chequer
    },
    {
        label: 'Propeller',
        value: Finish.propeller
    }
];
export const customMaterialExpressions = implementAdminCustomExpressions({
    CustomMaterial: {
        $rawMaterialOptions: ()=>rawMaterialOptions,
        $finishOptions: ()=>finishOptions
    }
});

//# sourceMappingURL=custom-material.js.map